import React from "react";
import { Typography, Box, Grid, Card, CardContent } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import { buildSiteUrl } from "../utils/urlHelpers";
import { 
  Business as CorporateIcon,
  People as FamilyIcon,
  Description as WillsEstatesIcon,
  Public as ImmigrationIcon,
  Home as RealEstateIcon,
  Gavel as LitigationIcon,
  Security as DefenseIcon,
  Assignment as NotaryIcon
} from "@mui/icons-material";

const PracticeAreaCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  backgroundColor: 'white',
  cursor: 'pointer',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    backgroundColor: '#f5f7fa',
  },
}));

const CardTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.1rem',
  color: '#0e3158',
  textAlign: 'center',
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#f5f7fa',
  borderRadius: '8px',
  width: '48px',
  height: '48px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(1.5),
  color: '#0e3158',
  margin: '0 auto',
}));

const practiceAreas = [
  {
    id: "business-corporate-law",
    title: "Corporate & Commercial Law",
    icon: <CorporateIcon sx={{ fontSize: 24 }} />
  },
  {
    id: "general-civil-litigation",
    title: "General Civil Litigation",
    icon: <LitigationIcon sx={{ fontSize: 24 }} />
  },
  {
    id: "wills-estates",
    title: "Wills & Estates",
    icon: <WillsEstatesIcon sx={{ fontSize: 24 }} />
  },
  {
    id: "real-estate",
    title: "Real Estate Law (Residential & Commercial)",
    icon: <RealEstateIcon sx={{ fontSize: 24 }} />
  },
  {
    id: "family-law",
    title: "Family Law",
    icon: <FamilyIcon sx={{ fontSize: 24 }} />
  },
  {
    id: "criminal-defence-law",
    title: "Criminal Defence",
    icon: <DefenseIcon sx={{ fontSize: 24 }} />
  },
  {
    id: "immigration-law",
    title: "Immigration Law",
    icon: <ImmigrationIcon sx={{ fontSize: 24 }} />
  },
  {
    id: "notary-commissioner",
    title: "Notary & Commissioner for Oaths",
    icon: <NotaryIcon sx={{ fontSize: 24 }} />
  }
];

const PracticeAreasGrid = () => {
  const handleLinkClick = (e, id) => {
    e.preventDefault();
    window.location.href = buildSiteUrl(`practice-areas#${id}`);
    setTimeout(() => {
      window.scrollBy(0, -120); // Adjust this value to get proper heading visibility
    }, 100);
  };

  // Separate the last two items for centered display
  const mainAreas = practiceAreas.slice(0, 6);
  const lastRowAreas = practiceAreas.slice(6);

  return (
    <>
      {/* First 6 practice areas in 2 rows of 3 */}
      <Grid container spacing={3}>
        {mainAreas.map((area) => (
          <Grid item xs={12} sm={6} md={4} key={area.id}>
            <PracticeAreaCard
              component={RouterLink}
              to={`/practice-areas#${area.id}`}
              onClick={(e) => handleLinkClick(e, area.id)}
              sx={{ textDecoration: 'none' }}
            >
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <IconWrapper>
                  {area.icon}
                </IconWrapper>
                <CardTitle variant="h6">
                  {area.title}
                </CardTitle>
              </CardContent>
            </PracticeAreaCard>
          </Grid>
        ))}
      </Grid>
      
      {/* Last row with 2 items centered */}
      <Grid container spacing={3} sx={{ mt: 0, justifyContent: 'center' }}>
        {lastRowAreas.map((area) => (
          <Grid item xs={12} sm={6} md={4} key={area.id}>
            <PracticeAreaCard
              component={RouterLink}
              to={`/practice-areas#${area.id}`}
              onClick={(e) => handleLinkClick(e, area.id)}
              sx={{ textDecoration: 'none' }}
            >
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <IconWrapper>
                  {area.icon}
                </IconWrapper>
                <CardTitle variant="h6">
                  {area.title}
                </CardTitle>
              </CardContent>
            </PracticeAreaCard>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default PracticeAreasGrid;